export default {
    accountTagsDeleteTags_title: "Eliminar Etiquetas",
    accountTagsDeleteTags_deleteWarning: "¿Esta seguro que desea eliminar las siguientes etiquetas?",
    accountTagsDeleteTags_errorSelectTag: "No puede seleccionar una etiqueta que se eliminará",
    accountTagsDeleteTags_typeToSearch: "Escriba para buscar...",
    accountTagsDeleteTags_selectTag: "Mover etiquetas anidadas y entidades a",
    accountTagsDeleteTags_deleted: "Etiquetas eliminadas exitosamente",
};